export const blockIconsTransportationDepartureBoardNew = (
	<span className='material-symbols-outlined'>departure_board</span>
);
